// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6508f8fa] .el-form--inline {\n  height: 35px;\n}\n[data-v-6508f8fa] .el-dialog__body {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: none !important;\n  padding: 15px !important;\n}", ""]);
// Exports
module.exports = exports;
